import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  fallbackLng: "th",
  lng: "th",
  resources: {
    en: {
      translations: require("./resources/en.json"),
    },
    th: {
      translations: require("./resources/th.json"),
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
});

i18n.languages = ["th", "en"];

export default i18n;
